import actionTypes from './../constants/actionTypes';

const initialState = {
    listing: {},
    indicatorsList: {},
    validateResponse: {},
};
export const stockReducer = (state = initialState, action) => {
    try {
        const { type, payload, status } = action;
        switch (type) {
            case actionTypes.STOCKS.STOCK_LIST: {
                return {
                    ...state,
                    listing: payload
                }
            }
            case actionTypes.STOCKS.VALIDATE_STOCK_RESULT: {
                return {
                    ...state,
                    validateResponse: payload
                }
            }
            case actionTypes.STOCKS.INDICATOR_LIST: {
                return {
                    ...state,
                    indicatorsList: payload
                }
            }
        }
        return state;
    } catch (error) {
        return state;
    }
}
export default stockReducer;
